import routerOptions0 from "/home/runner/work/coassemble-author/coassemble-author/frontend/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.5_db0@0.3.1_ioredis@5.6.0_less@4.2._06acc3e978b91c7506ec600ea179b7bd/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}